import { encodePacked } from 'viem';
import { GLOBAL_CONSTANTS } from '../../../../constants.js';
export const getTimeFramePolicy = (param) => {
    return {
        policy: GLOBAL_CONSTANTS.TIME_FRAME_POLICY_ADDRESS,
        address: GLOBAL_CONSTANTS.TIME_FRAME_POLICY_ADDRESS,
        initData: encodePacked(['uint128', 'uint128'], [BigInt(param.validUntil), BigInt(param.validAfter)]),
    };
};
//# sourceMappingURL=installation.js.map